<section class="left-nav-wrapper scroll-container">
  <div class="d-flex">
    <div class="col-8">
      <h1 class="page-title fw-bold">My Forms</h1>
    </div>
    <div class="col-4">
      <lib-ee-client-switcher></lib-ee-client-switcher>
    </div>
  </div>
  <div *ngIf="years != null && years.length > 0" class="myForms">
    @for (year of years; track year; let i = $index) {
      <div ngbAccordion #parentAccordion="ngbAccordion">
        <div
          ngbAccordionItem
          ngbAccordionItem="accItemName"
          #accItemName="ngbAccordionItem"
          [collapsed]="true">
          <h2 ngbAccordionHeader (click)="beforeYearPanelChange(year, i)">
            <button ngbAccordionButton>{{ year }}</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody class="px-0">
              <ng-template>
                <div *ngIf="yearlyData[year] != null && yearlyData[year].length > 0">
                  <div class="list-group list-group-flush">
                    <div
                      class="list-group-item d-flex align-middle formline"
                      *ngFor="let period of yearlyData[year]">
                      <div class="row w-100">
                        <div class="col-md-5 mt-auto mb-auto">
                          <button
                            class="link"
                            (click)="
                              downloadReport(
                                period.Id,
                                period.SubType,
                                period.Year,
                                period.FileName,
                                period.MimeType
                              )
                            ">
                            {{ period.FileName }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="yearlyData[year] != null && yearlyData[year].length == 0">
                  No Data for year {{ year }}
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <div *ngIf="years != null && years.length == 0" class="myForms">
    <h3>There are no forms on file.</h3>
  </div>
</section>
